import lassoUrls from "@/utils/lasso-urls";
import { Button } from "../generic/Button";
import { ErrorPage } from "./ErrorPage";

export const NotAuthenticated = () => {
  return (
    <ErrorPage
      icon="user-lock"
      title="Du har ikke adgang til Sales"
      message="Din konto har kun adgang til Lasso Insights. Log venligst ind med en Lasso Sales konto, eller gå til Lasso Insights."
      actions={
        <>
          <Button
            intent="secondary"
            onPress={() => {
              location.href = `${lassoUrls.getAppsUrl()}/logout?returnUrl=${encodeURIComponent(
                document.location.href,
              )}`;
            }}
          >
            Log ind
          </Button>

          <Button
            intent="primary"
            onPress={() => {
              location.href = `${lassoUrls.getInsightsUrl()}`;
            }}
          >
            Gå til Insights
          </Button>
        </>
      }
    />
  );
};
